import { EProductTourStatus, EProductTourType } from '@constants';
import { Button } from 'antd';
import { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNotNowTourStore } from '../../hooks/useNotNowTour';
import { useUserKnowNewDashboard } from '../../hooks/useUserKnowNewDashboard';

import {
  StyledModal,
  Wrapper,
  StyledImage,
  Footer,
  ButtonsWrapper,
  MessageWrapper,
  Title,
  SubTitle
} from './NewDashboardTourModal.styles';

import NEW_DASHBOARD_IMAGE from '@/assets/new_dashboard.png';
import { useWelcomeModalStore } from '@/hooks/useWelcomeModal';
import { useMutateProductTour, useProfile } from '@/store';

const TOUR_TYPE = EProductTourType.DASHBOARD_PRODUCT_TOUR;

export const NewDashboardTourModal = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { profile } = useProfile();
  const { mustShowModal, addAcceptedUser } = useUserKnowNewDashboard();
  const { isOpen: isWelcomeModalOpen } = useWelcomeModalStore();
  const { updateProductTour } = useMutateProductTour();
  const { open: openNotNowTour } = useNotNowTourStore();

  const [isModalOpen, setIsModalOpen] = useState(mustShowModal);

  const handleResetTour = useCallback(() => {
    if (!profile?._id) return;
    setIsModalOpen(false);
    addAcceptedUser(profile._id);
    updateProductTour({
      tours: {
        [TOUR_TYPE]: { status: EProductTourStatus.NOT_STARTED }
      }
    });
  }, [updateProductTour, profile?._id, addAcceptedUser]);

  const handleSkipTour = useCallback(() => {
    if (!profile?._id) return;
    setIsModalOpen(false);
    openNotNowTour();
    addAcceptedUser(profile._id);
    updateProductTour({
      tours: { [TOUR_TYPE]: { status: EProductTourStatus.SKIPPED } }
    });
  }, [updateProductTour, openNotNowTour, profile?._id, addAcceptedUser]);

  useEffect(() => {
    if (mustShowModal) {
      setIsModalOpen(true);
    } else {
      setIsModalOpen(false);
    }
  }, [mustShowModal]);

  if (!profile?._id) return null;

  return (
    <StyledModal open={isModalOpen && !isWelcomeModalOpen} closable={false} centered footer={null}>
      <Wrapper>
        <StyledImage src={NEW_DASHBOARD_IMAGE} alt="new-dashboard" />
        <Footer>
          <MessageWrapper>
            <Title>{t('NEW_DASHBOARD_MODAL_TITLE')}</Title>
            <SubTitle>{t('NEW_DASHBOARD_MODAL_SUBTITLE')}</SubTitle>
          </MessageWrapper>

          <ButtonsWrapper>
            <Button onClick={handleSkipTour}>{t('NOT_NOW')}</Button>
            <Button type="primary" onClick={handleResetTour}>
              {t('TAKE_A_TOUR')}
            </Button>
          </ButtonsWrapper>
        </Footer>
      </Wrapper>
    </StyledModal>
  );
};
